import { Box, Button, Paper, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { useScoresData } from "../hooks/useScores";
import img_back from "../image/result_backend.svg";
import img_data from "../image/result_data-science.svg";
import img_design from "../image/result_design.svg";
import img_front from "../image/result_frontend.svg";
import img_mobile from "../image/result_mobile.svg";
import theme from "../theme";

export const Result = () => {
  const scores = useScoresData();
  /* 各コースのデータ */
  const courses = [
    {
      title: "フロントエンド",
      value: scores.frontend,
      detail: `最前線で働きたいあなたはフロントエンドコースがおすすめ！\nフロントエンドコースでは、デザインカンプから一つのページを作りながらhtmlやcssを勉強したあと、JavaScriptやReactを勉強して案件に入ることが出来ます！レッツフロントエンド！`,
      img: img_front,
    },
    {
      title: "バックエンド",
      value: scores.backend,
      detail: `Web開発の仕組みを知りたいあなたはバックエンドコースがおすすめ！\nバックエンドコースでは、基本的なpythonの文法を学んだ後、pythonのWebフレームワークであるDjangoを使ってTwitterライクなWebアプリを作成します！レッツバックエンド！`,
      img: img_back,
    },
    {
      title: "モバイル",
      value: scores.mobile,
      detail: `一連の開発を行いたいあなたはモバイルコースがおすすめ！\nモバイルコースでは、FlutterというモバイルアプリフレームワークとFigmaというデザイン作成アプリを用いてデザインからのアプリ開発という実践的な内容を学びます！レッツモバイル！`,
      img: img_mobile,
    },
    {
      title: "データサイエンス",
      value: scores.data,
      detail: `協力して論理的解決を目指すあなたはデータサイエンスコースがおすすめ！\nデータサイエンスコースでは、pythonを学びながらデータの分析を行なっていき、同じコースの人たちと協力しながらプログラミングを用いた分析と課題解決を行います！レッツデータサイエンス！`,
      img: img_data,
    },
    {
      title: "デザイン",
      value: scores.design,
      detail: `創作表現が好きで感覚的なあなたはデザインコースがおすすめ！\nデザインコースでは、Figmaというデザイン作成アプリを用いて、デザインの本質的学習を行います。デザイン学習は多くの分野で活躍すること間違いなし！レッツデザイン！`,
      img: img_design,
    },
  ];

  /* 各コースの得点比較 */
  const sortedCourses = courses.slice().sort((a, b) => {
    if (a.value > b.value) {
      return -1;
    } else if (a.value < b.value) {
      return 1;
    } else {
      return Math.random() > 0.5 ? 1 : -1;
    }
  });

  /* 描画項目 */
  const result = {
    title: sortedCourses[0].title,
    detail: sortedCourses[0].detail,
    img: sortedCourses[0].img,
    secondCourse: sortedCourses[1].title,
    unsuitableCourse: sortedCourses[4].title,
  };

  /* 画面をリロードする関数 */
  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <ThemeProvider theme={theme}>
      <Typography
        component="h1"
        sx={{
          mt: { pc: "26px", mobile: "16px" },
          mb: "32px",
          fontSize: { pc: 24, mobile: 16 },
          lineHeight: 1.16,
          fontWeight: "regular",
          color: "text.primary",
          textAlign: "center",
        }}
      >
        結果発表
      </Typography>
      <Box
        sx={{
          mb: { pc: "19px", mobile: 0 },
          mx: "auto",
          width: { pc: "auto", mobile: "fit-content" },
        }}
      >
        <Typography
          sx={{
            mb: { pc: 2, mobile: 1 },
            fontSize: { pc: 20, mobile: 16 },
            lineHeight: 1.2,
          }}
        >
          あなたに向いてるのは…
        </Typography>
        <Box
          sx={{
            px: { pc: 1, mobile: 0.5 },
            fontSize: { pc: 48, mobile: 24 },
            lineHeight: 1.17,
            fontWeight: "bold",
            color: "text.paper",
            bgcolor: "background.dark",
            width: "fit-content",
          }}
        >
          {result.title}
        </Box>
      </Box>
      <Box
        sx={{
          maxWidth: { pc: "800px", mobile: "256px" },
          mx: "auto",
          display: "flex",
          flexDirection: { pc: "row", mobile: "column-reverse" },
          justifyContent: { pc: "space-between" },
          alignItems: { pc: "flex-start" },
          fontWeight: "regular",
          color: "text.secondary",
        }}
      >
        <Box sx={{ maxWidth: 410, mb: { pc: "25px", mobile: "32px" } }}>
          <Typography
            sx={{
              mb: { pc: "19px", mobile: "32px" },
              fontSize: 16,
              lineHeight: 1.88,
              whiteSpace: "pre-wrap",
            }}
          >
            {result.detail}
          </Typography>
          <Paper
            variant="outlined"
            sx={{
              maxWidth: 400,
              px: "16px",
              py: "8px",
            }}
          >
            <Typography sx={{ fontSize: 12, lineHeight: 2.5 }}>
              二番目に向いているコース：{result.secondCourse}
            </Typography>
            <Typography sx={{ fontSize: 12, lineHeight: 2.5 }}>
              向いていないかもしれないコース：{result.unsuitableCourse}
            </Typography>
          </Paper>
        </Box>
        <Box
          component="img"
          sx={{ width: "100%", maxWidth: 325 }}
          src={result.img}
          alt={result.title}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mb: { pc: "37px", sp: "32px" },
        }}
      >
        <Button variant="outlined" sx={{ minWidth: 207 }} onClick={refreshPage}>
          もう一度
        </Button>
      </Box>
    </ThemeProvider>
  );
};
